import type { ColumnsType, SortOrder } from 'antd/es/table/interface';
import type { ArticleSortField } from '@newsmedia/shared';
import type { ArticleRow } from '../../api/client';
import CoverThumb from './CoverThumb';
import StatusBadge from './StatusBadge';
import { fmtTaipei } from './status';

const muted = (v?: string | null) =>
  v ? <span className="text-gray-600">{v}</span> : <span className="text-gray-300">—</span>;

export interface ArticleSort {
  field: ArticleSortField;
  order: 'asc' | 'desc';
}

/** 文章列表表格欄位定義。排序在伺服器端做（資料有分頁），這裡只做受控的排序狀態。 */
export function buildColumns(onEdit: (id: string) => void, sort: ArticleSort): ColumnsType<ArticleRow> {
  const sortable = (field: ArticleSortField) => ({
    key: field,
    sorter: true,
    sortDirections: ['ascend', 'descend', 'ascend'] as SortOrder[],
    sortOrder: (sort.field === field ? (sort.order === 'asc' ? 'ascend' : 'descend') : null) as SortOrder,
  });
  return [
    {
      title: '封面',
      dataIndex: 'coverUrl',
      width: 88,
      render: (u: string | null) => <CoverThumb url={u} />,
    },
    {
      title: '標題',
      dataIndex: 'title',
      minWidth: 360,
      ...sortable('title'),
      render: (t: string, r) => (
        <button
          type="button"
          onClick={() => onEdit(r.id)}
          title={t}
          className="line-clamp-2 w-full cursor-pointer border-0 bg-transparent p-0 text-left text-[15px] font-medium leading-snug text-gray-800 transition-colors hover:text-[#dd7900]"
        >
          {t || <span className="text-gray-400">（未命名）</span>}
        </button>
      ),
    },
    { title: '分類', dataIndex: 'categoryNames', width: 120, render: muted, ...sortable('categoryNames') },
    { title: '作者', dataIndex: 'authorName', width: 110, render: muted, ...sortable('authorName') },
    {
      title: '狀態',
      dataIndex: 'status',
      width: 150,
      ...sortable('status'),
      render: (s: string, r) => <StatusBadge status={s} scheduledAt={r.scheduledAt} />,
    },
    {
      title: '更新時間',
      dataIndex: 'updatedAt',
      width: 170,
      ...sortable('updatedAt'),
      render: (t: number) => <span className="text-xs text-gray-400">{fmtTaipei(t)}</span>,
    },
  ];
}
